import { PayloadFilterExternalValidations } from "../../../../../../hooks/filter/typing"
import { removeAllReference } from "../../../../../../utils/methods/removedReference"
import { Item } from "../../../../../../utils/types/generals"

export const validateItemsMain = ({ name, body, departmentItem, setFilterData }: PayloadFilterExternalValidations & { departmentItem: Item[] }) => {
    let localeBody: Record<string, any> = removeAllReference(body)

    if (name === 'areas') {
        const { areas, departments: departmentsData } = localeBody
        const filteredDepartment = departmentsData?.filter((department: any) => areas.find((area: any) => area.value == department.areaId))
        let depatmentList: Item[] = []

        areas?.forEach((area: any) => {
            const id = area.value
            const childs = departmentItem?.filter((department) => department.areaId == id) || []
            depatmentList?.push(...childs)
        })

        setFilterData((prev) => ({
            ...prev,
            departments: filteredDepartment,
        }))

        localeBody = { ...localeBody, departments: filteredDepartment, }
        return { localeBody, depatmentList }
    }

    return { localeBody, depatmentList: departmentItem }
}
export const validateItems = ({ name, body, departmentItem, setFilterData }: PayloadFilterExternalValidations & { departmentItem: Item[] }) => {
    let localeBody: Record<string, any> = removeAllReference(body)

    if (name === 'areas') {
        const { areas, } = localeBody
        const filteredDepartment = null
        let depatmentList: Item[] = departmentItem?.filter((department) => department.areaId == areas?.value) || []

        setFilterData((prev) => ({
            ...prev,
            departments: filteredDepartment,
        }))

        localeBody = { ...localeBody, departments: filteredDepartment, }
        return { localeBody, depatmentList }
    }

    return { localeBody, depatmentList: departmentItem }
}